export default __webpack_public_path__ + "static/media/scenario.89e1b4dd.svg";